export default "__VITE_ASSET__DHpt3qSw__"